import axios from 'axios'
import { API_ROOT, AUTH_ROOT } from 'config'
import qs from 'qs'
import _ from 'lodash'
import camelcaseKeysDeep from 'camelcase-keys-deep'
import moment from 'moment'


export const MydAPI = axios.create({
  baseURL: API_ROOT,
  timeout: 60000,
  headers: {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }
})

const UocApi = {
  host: 'https://cv.uoc.edu/webapps/uocapi',
  clientId: 'hJ9OlJNg9r033b7JYMQdDmbWiCUZWVy7vPVvGFHRcp0LscIGLLugb3GErKJAkSwqSXL7egJgcmrEMjK834qwjaRoDQLnsHcHV921l3ah8GopqQglwmJtPYb4wV1d15fB',
  redirectUri: 'http://www.mydocumenta.com/uoc-openapi.php',
  state: btoa(JSON.stringify({'redirectURL': window.location.href}))
}

MydAPI.interceptors.request.use(config => {
  let search = qs.parse(window.location.search.replace('?', '')),
      token = localStorage.getItem('mydToken'),
      uocCredentials = JSON.parse(localStorage.getItem('uocCredentials')) || false
  // [TODO] Check if token is valid
  // [TODO] Refresh token if it is needed

  if (uocCredentials !== false) {
    let expiration = moment(uocCredentials.expiration),
        today = moment()

    if (today > expiration) {
      window.location = `${UocApi.host}/oauth/authorize?response_type=code&scope=READ WRITE READ_GRADEBOOK&client_id=${UocApi.clientId}&redirect_uri=${UocApi.redirectUri}&state=${UocApi.state}`
    }
  }

  if (token === 'undefined')
    token = _.get(search, 'token', {})

  if (token){
    localStorage.setItem('mydToken', token)
    config.headers.common.Authorization = `Bearer ${token}`
  }
  return config
})

MydAPI.interceptors.response.use(response => {
  if (response.config.url.search(`/small/i18n/`) === -1) {
    return {
      ...response,
      data: camelcaseKeysDeep(response.data),
    }
  }
  return response

}, function (error) {
  return Promise.reject(error)
})

export const MydUploadAPI = axios.create({
  baseURL: API_ROOT,
  timeout: 60000,
  headers: {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/x-www-form-urlencoded',
  }
})

export const MydAuth = axios.create({
  baseURL: AUTH_ROOT,
  timeout: 60000,
  headers: {
    'Accept': 'application/x-www-form-urlencoded',
    'Content-Type': 'application/x-www-form-urlencoded',
    'Cache-Control': 'no-cache',
  }
})

MydAuth.interceptors.request.use(config => {
  let token = localStorage.getItem('mydToken')
  config.headers.common.Authorization = `Bearer ${token}`
  return config
})
